import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SuggestionListsService } from '../../../../services/suggestion-lists.service';
import { Router } from '@angular/router';
import { AdminService } from '../../../../../../../services/admin.service';
import { SuggestionListUserOption } from '../../suggestion-list-user-option.model';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

const ACTION_REDIRECT = 'redirect';
const ACTION_CANCEL = 'cancel';
const ACTION_POSTPONE = 'postpone';
const ACTION_UPDATE_POSTPONEMENT = 'updatePostponement';
const ACTION_IMPLEMENT = 'implement';
const ACTION_CLOSE = 'close';
const ACTION_RESTORE = 'restore';
const ACTION_CREATE_CEO = 'createCEO';
const EMPTY_TEXT = '';
const HTTP_OK = 200;
const HTTP_CREATED = 201;
const HTTP_CONFLICT = 409;
const EXPIRED_ROUTE_PART = 'ex-suggestion-expired';
const EX_NOTIFICATIONS_ROUTE = '/ex-notifications';
const MODAL_DISMISS_REASON = 'Cross click';
const REDIRECT_SUCCESS = 'REASSIGNING_COMPLETED_SUCCESSFULLY';
const REDIRECT_ERROR = 'C_R_S_E';
const REDIRECT_LIMIT_ERROR = 'T_O_R_S';
const CANCEL_SUCCESS = 'CANCELLATION_WAS_SUCCESSFU';
const CANCEL_ERROR = 'C_H_S';
const POSTPONE_SUCCESS = 'POSTPONING_WAS_SUCCESSFUL';
const POSTPONE_ERROR = 'P_H_S';
const IMPLEMENT_SUCCESS = 'IMPLEMENTATION_WAS_SUCCESSFUL';
const IMPLEMENT_ERROR = 'I_H_P';
const RESTORE_ERROR = 'SERVER_ERROR';
const INVALID_POSTPONE_DATE = 'CHOOSE_DATE_FOR_AT_LEAST_ONE_DAY_MORE_THAN_TODAY.';
const POSTPONE_UNCERTAIN = 'SUGGESTION_POSTPONE_UNCERTAIN';
const POSTPONE_ACCESS_DENIED = 'SUGGESTION_ACCESS_DENIED';
const ACTION_REJECTED_CODE = 'SUGGESTION_ACTION_REJECTED';
const POSTPONED_STATUS = 'POSTPONE';
const HTTP_NETWORK_ERROR = 0;
const HTTP_FORBIDDEN = 403;
const HTTP_SERVER_ERROR = 500;
const DATE_SEPARATOR = '-';
const YEAR_INDEX = 0;
const MONTH_INDEX = 1;
const DAY_INDEX = 2;
const STRING_TYPE = 'string';

interface RequestedPostponement {
  date: NgbDateStruct;
  reason: string;
}

interface SavedPostponement {
  status: string;
  postponedUntil?: string;
  reasonToPostpone: string;
}

@Component({
  selector: 'app-action-sl-popup',
  templateUrl: './action-sl-popup.component.html',
  styleUrls: ['./action-sl-popup.component.css']
})
export class ActionSlPopupComponent implements OnInit, OnDestroy {
  slList = null;
  actionText = '';
  reasonAction = '';
  btnActionText = '';
  action = '';
  dateOfPostpone: NgbDateStruct;
  todayDate: NgbDateStruct;
  notifyID;
  selectedRedirectDivision;
  selectedSLList;

  responseResultText = '';
  showErrorMsg = false;
  showSuccessMsg = false;
  disableBtn = false;

  departmentList = [];
  usersList: SuggestionListUserOption[] = [];
  selectDepartment = null;
  selectUser = null;
  countOfDays = 1;
  private destroy$ = new Subject<void>();

  constructor(public activeModal: NgbActiveModal,
    private router: Router,
    public suggestionListsService: SuggestionListsService,
    private adminService: AdminService) {
  }

  ngOnInit() {
    this.responseResultText = '';
    this.showErrorMsg = false;
    this.showSuccessMsg = false;
    this.disableBtn = false;

    const date = new Date();

    this.dateOfPostpone = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };

    this.todayDate = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  }

  onDepartmentChange(): void {
    if (this.selectDepartment) {
      this.selectUser = null;
      this.usersList = [];
      this.adminService.getStaffedGroupUserOptions(this.selectDepartment).subscribe(
        (response: HttpResponse<SuggestionListUserOption[]>) => this.usersList = response.body || [],
        () => this.usersList = []
      );
    } else {
      this.usersList = [];
    }
  }


  setSL(sl) {
    this.slList = sl;
  }

  disabledBtn() {
    return this.reasonAction.length >= 3;
  }

  setAllDevision(data) {
    this.departmentList = data;
  }

  setDivisionId(a, b, c) {
    this.selectedRedirectDivision = a;
    this.selectedSLList = b;
    this.notifyID = c;
  }

  setAction(actionPressrd) {
    this.action = actionPressrd;
    switch (this.action) {
      case 'redirect':
        this.actionText = 'REASON_FOR_REASSIGN';
        this.btnActionText = 'Ok';
        break;
      case 'cancel':
        this.actionText = 'CANCELLATION_REASON';
        this.btnActionText = 'CANCEL_LIST';
        break;
      case 'postpone':
      case 'updatePostponement':
        this.actionText = 'POSTPONING_REASON';
        this.btnActionText = 'POSTPONE_LIST';
        break;
      case 'implement':
        this.actionText = 'IMPLEMENTATION_RESULT';
        this.btnActionText = 'IMPLEMENT_SUGGESTION_LIST';
        break;
      case 'close':
        this.actionText = 'REASON';
        this.btnActionText = 'CANCEL';
        break;
      case 'restore':
        this.actionText = 'REASON';
        this.btnActionText = 'RESTORE';
        break;
      case 'createCEO':
          this.actionText = 'DESCRIPTION';
          this.btnActionText = 'CREATE';
          break;
    }
  }

  onAction() {
    switch (this.action) {
      case ACTION_REDIRECT: return this.redirectToNewHead();
      case ACTION_CANCEL: return this.cancelRequest();
      case ACTION_POSTPONE: return this.postponeRequest();
      case ACTION_UPDATE_POSTPONEMENT: return this.updatePostponementRequest();
      case ACTION_IMPLEMENT: return this.implementRequest();
      case ACTION_CLOSE: return this.cancelApprovalRequest();
      case ACTION_RESTORE: return this.restoreRequest();
      case ACTION_CREATE_CEO: return this.closeWithCeoTaskRequest();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private closeWithCeoTaskRequest(): void {
    const taskRequest = {
      slId: this.selectedSLList,
      taskDeadline: this.countOfDays,
      userId: this.selectUser,
      groupId: this.selectDepartment,
      taskDescription: this.reasonAction
    };
    this.activeModal.dismiss(taskRequest);
  }

  markNotify(itemId) {
    const sendingParams = {
      id: itemId,
      notificationCategory: "SUGGESTION"
    };
    this.adminService.notifyIsView(sendingParams).subscribe(
      (response: any) => { },
      () => {
      }
    );
  }

  redirectToNewHead() {
    if (!this.beginAction()) {
      return;
    }
    const request = this.suggestionListsService.redirectSL(
      this.reasonAction, this.selectedRedirectDivision, this.selectedSLList
    );
    this.observeRedirectAction(request);
  }

  // CANCEL SL
  cancelRequest() {
    if (!this.beginAction()) {
      return;
    }
    const request = this.suggestionListsService.cancelSL(this.reasonAction, this.slList.id);
    this.observeAction(request, CANCEL_SUCCESS, CANCEL_ERROR);
  }

  // POSTPONE SL
  postponeRequest() {
    if (!this.isDateValid()) {
      this.failAction(INVALID_POSTPONE_DATE);
      return;
    }
    if (!this.beginAction()) {
      return;
    }
    const request = this.suggestionListsService.postponeSL(
      this.reasonAction, this.dateOfPostpone, this.slList.id
    );
    this.observePostponement(request);
  }

  updatePostponementRequest() {
    if (!this.isDateValid()) {
      this.failAction(INVALID_POSTPONE_DATE);
      return;
    }
    if (!this.beginAction()) {
      return;
    }
    const request = this.suggestionListsService.updatePostponementSL(
      this.reasonAction, this.dateOfPostpone, this.slList.id
    );
    this.observePostponement(request);
  }

  private observePostponement(request: Observable<HttpResponse<Object>>): void {
    const expected = {date: Object.assign({}, this.dateOfPostpone), reason: this.reasonAction};
    request.takeUntil(this.destroy$).subscribe(
      response => this.finishAction(response, POSTPONE_SUCCESS, POSTPONE_ERROR),
      error => this.handlePostponementFailure(error, expected)
    );
  }

  private handlePostponementFailure(error: HttpErrorResponse, expected: RequestedPostponement): void {
    const status = this.getErrorStatus(error);
    if (status === HTTP_NETWORK_ERROR || status >= HTTP_SERVER_ERROR) {
      this.checkSavedPostponement(expected);
      return;
    }
    if (status === HTTP_FORBIDDEN) {
      this.failAction(POSTPONE_ACCESS_DENIED);
      return;
    }
    const body = error && error.error;
    this.failAction(body && body.code === ACTION_REJECTED_CODE && typeof body.message === STRING_TYPE
      ? body.message : POSTPONE_ERROR);
  }

  private checkSavedPostponement(expected: RequestedPostponement): void {
    this.suggestionListsService.getSLByID(this.slList.id).takeUntil(this.destroy$).subscribe(
      (response: HttpResponse<SavedPostponement>) => {
        if (response.status === HTTP_OK && this.matchesPostponement(response.body, expected)) {
          this.finishAction(response, POSTPONE_SUCCESS, POSTPONE_ERROR);
          return;
        }
        this.failAction(POSTPONE_UNCERTAIN);
      },
      () => this.failAction(POSTPONE_UNCERTAIN)
    );
  }

  private matchesPostponement(saved: SavedPostponement, expected: RequestedPostponement): boolean {
    if (!saved || saved.status !== POSTPONED_STATUS || !saved.postponedUntil
        || saved.reasonToPostpone !== expected.reason) {
      return false;
    }
    const date = saved.postponedUntil.split(DATE_SEPARATOR).map(Number);
    return date[YEAR_INDEX] === expected.date.year && date[MONTH_INDEX] === expected.date.month
      && date[DAY_INDEX] === expected.date.day;
  }

  implementRequest() {
    if (!this.beginAction()) {
      return;
    }
    const request = this.suggestionListsService.implementSL(this.reasonAction, this.slList.id);
    this.observeAction(request, IMPLEMENT_SUCCESS, IMPLEMENT_ERROR);
  }

  private cancelApprovalRequest(): void {
    if (!this.beginAction()) {
      return;
    }
    const request = this.suggestionListsService.cancelSuggesionFull(this.slList.id, this.reasonAction);
    this.observeAction(request, CANCEL_SUCCESS, CANCEL_ERROR);
  }

  private restoreRequest(): void {
    if (!this.beginAction()) {
      return;
    }
    const request = this.suggestionListsService.restoreSuggesionFull(this.slList.id, this.reasonAction);
    this.observeAction(request, CANCEL_SUCCESS, RESTORE_ERROR);
  }

  private beginAction(): boolean {
    if (this.disableBtn) {
      return false;
    }
    this.responseResultText = EMPTY_TEXT;
    this.showErrorMsg = false;
    this.showSuccessMsg = false;
    this.disableBtn = true;
    return true;
  }

  private observeAction(
    request: Observable<HttpResponse<Object>>, successText: string, errorText: string
  ): void {
    request.takeUntil(this.destroy$).subscribe(
      response => this.finishAction(response, successText, errorText),
      () => this.failAction(errorText)
    );
  }

  private observeRedirectAction(request: Observable<HttpResponse<Object>>): void {
    request.takeUntil(this.destroy$).subscribe(
      response => this.finishAction(response, REDIRECT_SUCCESS, REDIRECT_ERROR),
      error => this.failAction(
        this.getErrorStatus(error) === HTTP_CONFLICT ? REDIRECT_LIMIT_ERROR : REDIRECT_ERROR
      )
    );
  }

  private finishAction(response: HttpResponse<Object>, successText: string, errorText: string): void {
    if (response.status !== HTTP_OK && response.status !== HTTP_CREATED) {
      this.failAction(errorText);
      return;
    }
    this.responseResultText = successText;
    this.showErrorMsg = false;
    this.showSuccessMsg = true;
    this.disableBtn = false;
    this.completeAction();
  }

  private completeAction(): void {
    if (this.router.url.includes(EXPIRED_ROUTE_PART)) {
      this.markNotify(this.notifyID);
      this.router.navigate([EX_NOTIFICATIONS_ROUTE]);
      this.activeModal.dismiss(MODAL_DISMISS_REASON);
      return;
    }
    this.activeModal.close(true);
  }

  private failAction(errorText: string): void {
    this.responseResultText = errorText;
    this.showErrorMsg = true;
    this.showSuccessMsg = false;
    this.disableBtn = false;
  }

  private getErrorStatus(error: HttpErrorResponse): number {
    return error && error.error && error.error.status ? error.error.status : error && error.status;
  }


  // Date validation for postponing
  isDateValid() {
    if (this.dateOfPostpone.year > this.todayDate.year) {
      return true;
    } else if (this.dateOfPostpone.year === this.todayDate.year) {
      // This year
      if (this.dateOfPostpone.month > this.todayDate.month) {
        return true;
      } else if (this.dateOfPostpone.month === this.todayDate.month) {
        return this.dateOfPostpone.day > this.todayDate.day;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/components/view-suggestion-list/popups/action-sl-popup/action-sl-popup.component.ts